import { JSONObject, bind } from 'immer-yjs';
import * as Y from 'yjs';

import { Project } from 'src/store/state/projects';

/**
 * Convert a Y.Doc to a Project object.
 *
 * Reads the root Y.Map via immer-yjs snapshot and returns a plain Project object.
 *
 * @param doc - A Y.Doc containing a Project in its root 'project' Y.Map
 * @returns The plain Project object
 */
export const yDocToProject = (doc: Y.Doc): Project => {
  const rootMap = doc.getMap('project');
  const binder = bind<JSONObject>(rootMap);
  const snapshot = binder.get();
  binder.unbind();
  return snapshot as unknown as Project;
};
